import { createSlice } from "@reduxjs/toolkit";

import {
  addApprovalAction,
  addRecruitmentTrackerAction,
  createRecruitmentModuleOpenPositionAction,
  deleteRecruitmentModuleOpenPositionAction,
  deleteRecruitmentTrackerAction,
  getApprovalListAction,
  getRecruitmentModuleOpenPositionAction,
  getRecruitmentTrackerBulkUploadHistoryAction,
  getRecruitmentTrackerListAction,
  getResignationUpdatesListAction,
  getSingleRecruitmentTrackerListAction,
  hikeReasonSubmitAction,
  recruitementTrackerBulkUploadAction,
  sendFeedbackApprovalAction,
  updateHiringCheckListDataAction,
  updateRecruitmentModuleOpenPositionAction,
  updateRecruitmentTrackerListAction,
  getWeightedAverageReportAction,
  getRecruitmentTrackerStageCountAction,
  getDeprecatedRecruitmentTrackerListAction,
} from "@/redux/hrms/actions";
import type { HrmsType } from "@/redux/hrms/hrmsTypes";
import { initialState } from "@/redux/hrms/initialState";
import { hrmsReducer } from "@/redux/hrms/reducer";

export const hrmsSlice = createSlice({
  name: "hrms",
  initialState,
  reducers: hrmsReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getRecruitmentModuleOpenPositionAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getRecruitmentModuleOpenPositionAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          openPoisitionList: result,
          // success,
          openPositionTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getRecruitmentModuleOpenPositionAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createRecruitmentModuleOpenPositionAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createRecruitmentModuleOpenPositionAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createRecruitmentModuleOpenPositionAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateRecruitmentModuleOpenPositionAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateRecruitmentModuleOpenPositionAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateRecruitmentModuleOpenPositionAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteRecruitmentModuleOpenPositionAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteRecruitmentModuleOpenPositionAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteRecruitmentModuleOpenPositionAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getRecruitmentTrackerListAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getRecruitmentTrackerListAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          recruitmentTrackerList: [
            ...state.recruitmentTrackerList,
            ...result.result,
          ],
          recruitmentTrackerTotalCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getRecruitmentTrackerListAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getDeprecatedRecruitmentTrackerListAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getDeprecatedRecruitmentTrackerListAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          recruitmentTrackerList: result?.result,
          recruitmentTrackerTotalCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getDeprecatedRecruitmentTrackerListAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getRecruitmentTrackerStageCountAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getRecruitmentTrackerStageCountAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          recruitmentTrackerStageCount: result,
        };
      }
    );

    builder.addCase(
      getRecruitmentTrackerStageCountAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(addRecruitmentTrackerAction.pending, (state: HrmsType) => ({
      ...state,
      addEditFetching: true,
    }));

    builder.addCase(
      addRecruitmentTrackerAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            addEditFetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          addEditFetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      addRecruitmentTrackerAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        addEditFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateRecruitmentTrackerListAction.pending,
      (state: HrmsType) => ({
        ...state,
        addEditFetching: true,
      })
    );

    builder.addCase(
      updateRecruitmentTrackerListAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            addEditFetching: false,
          };
        }
        return {
          ...state,
          addEditFetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateRecruitmentTrackerListAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        addEditFetching: false,
      })
    );

    builder.addCase(
      getSingleRecruitmentTrackerListAction.pending,
      (state: HrmsType) => ({
        ...state,
        addEditFetching: true,
      })
    );

    builder.addCase(
      getSingleRecruitmentTrackerListAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            addEditFetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          addEditFetching: false,
          // success,
          singleRecruitmentTrackerList: result,
        };
      }
    );

    builder.addCase(
      getSingleRecruitmentTrackerListAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        addEditFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      deleteRecruitmentTrackerAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteRecruitmentTrackerAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteRecruitmentTrackerAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateHiringCheckListDataAction.pending,
      (state: HrmsType) => ({
        ...state,
        addEditFetching: true,
      })
    );

    builder.addCase(
      updateHiringCheckListDataAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          addEditFetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateHiringCheckListDataAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        addEditFetching: false,
      })
    );

    builder.addCase(getApprovalListAction.pending, (state: HrmsType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getApprovalListAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          approvalList: result,
          approvalTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getApprovalListAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(addApprovalAction.pending, (state: HrmsType) => ({
      ...state,
      addEditFetching: true,
    }));

    builder.addCase(
      addApprovalAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            addEditFetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          addEditFetching: false,
          statusCode: status_code,
          message: message,
          success,
        };
      }
    );

    builder.addCase(
      addApprovalAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        addEditFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      recruitementTrackerBulkUploadAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      recruitementTrackerBulkUploadAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, data = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          hrmsBulkUploadData: payload,
        };
      }
    );

    builder.addCase(
      recruitementTrackerBulkUploadAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getRecruitmentTrackerBulkUploadHistoryAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getRecruitmentTrackerBulkUploadHistoryAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { status_code, result, message, success } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          bulkUploadHistoryData: result?.result,
          bulkUploadHistoryCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getRecruitmentTrackerBulkUploadHistoryAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );
    builder.addCase(hikeReasonSubmitAction.pending, (state: HrmsType) => ({
      ...state,
      addEditFetching: true,
    }));

    builder.addCase(
      hikeReasonSubmitAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            addEditFetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          addEditFetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );
    builder.addCase(
      hikeReasonSubmitAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        addEditFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
    builder.addCase(
      getResignationUpdatesListAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      getResignationUpdatesListAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { status_code, result, message, success } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          resignationListData: result?.data,
          resignationListTotalCount: result?.count,
        };
      }
    );

    builder.addCase(
      getResignationUpdatesListAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );
    builder.addCase(sendFeedbackApprovalAction.pending, (state: HrmsType) => ({
      ...state,
      fetching: true,
    }));
    builder.addCase(
      sendFeedbackApprovalAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { status_code, message, success } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          success: success,
          fetching: false,
          statusCode: status_code,
          message: message,
        };
      }
    );

    builder.addCase(
      sendFeedbackApprovalAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );
    builder.addCase(
      getWeightedAverageReportAction.pending,
      (state: HrmsType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      getWeightedAverageReportAction.fulfilled,
      (state: HrmsType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          weightedAverageReportList: [
            ...state.weightedAverageReportList,
            ...(result ?? []),
          ],
          weightedAverageReportTotalCount: total_count ?? result?.length ?? 0,
        };
      }
    );
    builder.addCase(
      getWeightedAverageReportAction.rejected,
      (state: HrmsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
  },
});
export const {
  resetHrmsError,
  resetHrmsSuccess,
  resetHrmsFetching,
  resetHrmsMessage,
  resetHrmsStatusCode,
  resetOpenPoisitionList,
  resetOpenPositionTotalCount,
  resetRecruitmentTrackerList,
  resetRecruitmentTrackerTotalCount,
  resetSingleRecruitmentTrackerList,
  resetUniqueCheckFetching,
  resetUniqueCheckMessage,
  resetApprovalList,
  resetRecruitmentTrackerStageCountList,
  resetHrmsBulkUpload,
  resetBulkUploadHistoryCount,
  resetBulkUploadHistoryData,
  resetResignationListData,
  resetResignationListTotalCount,
  resetWeightedAverageReportList,
  resetWeightedAverageReportTotalCount,
  setRecruitmentSort,
  resetRecruitmentSortingUI,
  updateDraftFilter,
  applyFilters,
  resetDraft,
  resetAllFilters,
  syncDraftWithApplied,
  setRecruitmentSearchTerm,
  resetRecruitmentSearchTerm,
  setScrollPosition,
  resetScroll,
  setActiveRecruitmentTab,
} = hrmsSlice.actions;
